// extracted by mini-css-extract-plugin
export default {"loading":"LoadingSpinner_loading__6M1ZE","loading1":"LoadingSpinner_loading1__5OEmS","loading2":"LoadingSpinner_loading2__NgpES","loading3":"LoadingSpinner_loading3__2NqIZ"};